
import React, { useRef, useEffect } from 'react';
import TimelineItem from './TimelineItem';
import { History, Briefcase, Building, Shield, Star } from 'lucide-react';

const Timeline = () => {
  const timelineRef = useRef<HTMLDivElement>(null);
  
  useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting && timelineRef.current) {
          timelineRef.current.classList.add('animate-fade-in');
          
          // Animate timeline items sequentially
          const items = timelineRef.current.querySelectorAll('.timeline-item');
          items.forEach((item, index) => {
            setTimeout(() => {
              (item as HTMLElement).style.opacity = '1';
              (item as HTMLElement).style.transform = 'translateY(0)';
            }, index * 200);
          });
        }
      });
    }, { threshold: 0.1 });
    
    if (timelineRef.current) observer.observe(timelineRef.current);
    
    return () => observer.disconnect();
  }, []);
  
  return (
    <div className="mb-16">
      <h3 className="text-2xl font-bold mb-8 text-center">The Truecore Story</h3>
      
      <div 
        ref={timelineRef} 
        className="relative opacity-100 transition-all duration-700"
      >
        {/* Timeline center line */}
        <div className="absolute left-1/2 transform -translate-x-1/2 h-full w-1 bg-muted"></div>
        
        {/* Timeline items */}
        <div className="space-y-12">
          <TimelineItem 
            year="2010" 
            title="Foundation of Truecore" 
            description="Started as a specialized hardware solutions provider with a focus on custom gadget development. Our initial team of 10 passionate engineers laid the groundwork for innovation."
            position="left"
            icon={<History className="h-5 w-5" />}
          />
          
          <TimelineItem 
            year="2015" 
            title="Innovation Breakthrough" 
            description="Launched our first patented smart device ecosystem, revolutionizing how businesses interact with IoT technology. Expanded our R&D department to 50+ specialists."
            position="right"
            icon={<Briefcase className="h-5 w-5" />}
          />
          
          <TimelineItem 
            year="2018" 
            title="Global Expansion" 
            description="Opened offices in major tech hubs across Asia and Europe. Established partnerships with leading technology manufacturers and started serving Fortune 500 clients."
            position="left"
            icon={<Building className="h-5 w-5" />}
          />
          
          <TimelineItem 
            year="2021" 
            title="Security Excellence" 
            description="Achieved ISO 27001 certification for our secure hardware development processes. Launched our cybersecurity-focused product line for enterprise clients."
            position="right"
            icon={<Shield className="h-5 w-5" />}
          />
          
          <TimelineItem 
            year="2023" 
            title="Industry Recognition" 
            description="Received multiple industry awards for innovation in custom hardware solutions. Surpassed 1000+ enterprise clients globally and expanded our product portfolio."
            position="left"
            icon={<Star className="h-5 w-5" />}
          />
        </div>
      </div>
    </div>
  );
};

export default Timeline;
